import React, { useContext, useEffect, useState } from 'react';
import '../../../../App.css';
import SpTextArea from '../../../../components/atoms/SpTextArea';
import SpTextInput from '../../../../components/atoms/SpTextInput';
import { Grid } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import moment from 'moment';
import SpButton from '../../../../components/atoms/SpButton';
import { getResourceFromServer } from '../../../../models/actions/Files';
import { UserSessionContext } from '../../../../App';
moment.locale('it');

const StationOpenedReportDetailDialog = (props) => {
  const [fileURL, setFileURL] = useState(null);
  const { selectedReport, register, handleSubmit, updateCurrentReport } = props;

  const { authData, setAuthData } = useContext(UserSessionContext);

  const fetchData = async () => {
    try {
      console.log('selectedReport22', selectedReport);
      const resourceDetail = await getResourceFromServer({ file: selectedReport?.file }, authData.accessToken);
      if (resourceDetail) setFileURL(resourceDetail);
    } catch (error) {
      props.snackbarShowErrorMessage('Errore file!');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Grid
      container
      direction="row"
    >
      <Grid
        item
        xs={5}
      >
        <img
          src={fileURL}
          style={{ width: '300px', height: '300px' }}
        />
      </Grid>
      <form onSubmit={handleSubmit(updateCurrentReport)}>
        <Grid
          item
          xs={6}
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={11}
          >
            <SpTextInput
              type="date"
              label={'Data di apertura della segnalazione'}
              variant="dialogRentDetail"
              inputRef={register}
              name={'creation_date'}
              defaultValue={moment(selectedReport?.creation_date).format('YYYY-MM-DD')}
            />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpTextInput
              label={`Ammontare addebito (€)`}
              variant="dialogRentDetail"
              inputRef={register}
              name={'amount_to_pay'}
              defaultValue={selectedReport?.amount_to_pay ? selectedReport?.amount_to_pay : '0'}
            />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpTextInput
              disabled
              label={`Parte danneggiata`}
              variant="dialogRentDetail"
              inputRef={register}
              name={'bike_part'}
              defaultValue={selectedReport?.bike_part}
            />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpTextInput
              disabled
              label={`Dettaglio danno`}
              variant="dialogRentDetail"
              inputRef={register}
              name={'bike_part_detail'}
              defaultValue={selectedReport?.bike_part_detail}
            />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpTextArea
              label="Note"
              inputRef={register}
              name="note"
              defaultValue={selectedReport?.note}
            />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpButton
              text={'Modifica'}
              style={{ width: '100%' }}
              buttonType="accept"
              type="submit"
            />
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default withSnackbar(StationOpenedReportDetailDialog);
